import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "LISTE DES DERNIERES REGLEMENTS", -1)
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Client "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Montant regler "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Reste à payer "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Vente ")
  ])
], -1)
const _hoisted_8 = { class: "shadow-none lh-1 fw-bold ps-0" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-semibold text-black-emphasis" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_12 = { class: "badge text-outline-success" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/Reglements",
          class: "card-btn fw-medium d-inline-block text-decoration-none transition ps-10 pe-10 pt-5 pb-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Voir la liste ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (reg) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: reg.id
              }, [
                _createElementVNode("th", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/product-details",
                    class: "text-decoration-none text-black-emphasis"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((reg) ? reg.id : ""), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("td", _hoisted_9, _toDisplayString((reg) ? _ctx.format_Date(reg.dateReglement) : ""), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString((reg.vente) ?
                  " [ "+reg.vente.client.code+" ] "+reg.vente.client.nom+" "+reg.vente.client.prenoms
                   : ""), 1),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, [
                    _createElementVNode("b", null, _toDisplayString((reg.montant) ? reg.montant : ""), 1),
                    _createTextVNode(" Fcfa ")
                  ])
                ]),
                _createElementVNode("td", _hoisted_13, _toDisplayString((reg.restAPayer) ? reg.restAPayer : ""), 1),
                _createElementVNode("td", _hoisted_14, " #" + _toDisplayString((reg.vente.id) ? reg.vente.id : ""), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}